import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
// import { injectTemplateRef } from '@angular/core/src/render3/view_engine_compatibility';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  public CurrentMenu: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentMenu$ = this.CurrentMenu.asObservable();
  public CurrentSite: BehaviorSubject<any> = new BehaviorSubject(null);
  public CurrentSite$ = this.CurrentSite.asObservable();
  toggleAllSubject = new Subject<boolean>();
  selectedMenus = [];

  public disconnect() {
    this.CurrentMenu = new BehaviorSubject<any>(null);
    this.CurrentMenu$ = this.CurrentMenu.asObservable();
    this.CurrentSite = new BehaviorSubject<any>(null);
    this.CurrentSite$ = this.CurrentSite.asObservable();
  }

  setCurrentMenu(menu) {
    this.CurrentMenu.next(menu);
  }

  setCurrentSite(site) {
    this.CurrentSite.next(site);
  }

  back() {
    window.history.back();
  }

  // public Components: BehaviorSubject<any> = new BehaviorSubject(null);
  // public Components$ = this.Components.asObservable();




  // public disconnect() {
  //   this.Components = new BehaviorSubject<any>(null);
  //   this.Components$ = this.Components.asObservable();
  // }

  // updateComponents() {
  //   this.Components.next(true);
  // }


 

  addChilds() {

  }

  checkSelected() {
    return JSON.parse(localStorage.getItem('selectedMenu')) || [];
  }

  addChildMenu(item) {
    let menuItem = this.selectedMenus.find(element => item.id == element.id);
    if (!menuItem) {
      this.selectedMenus.push(item);
      if (item.childs.length > 0) {
        item.childs.forEach(childsElement => {
          this.addChildMenu(childsElement);
        });
      }
      return this.selectedMenus;
    }
  }

  subtractChildMenu(item) {
    let menuItem = this.selectedMenus.find(element => item.id == element.id);
    let itemIndex = this.selectedMenus.indexOf(menuItem);
    if (itemIndex != -1) {
      this.selectedMenus.splice(itemIndex, 1);
    }
    if (item.childs.length > 0) {
      item.childs.forEach(childsElement => {
        this.subtractChildMenu(childsElement);
      });
    }
    return this.selectedMenus;
  }

  isMenuChecked(item) {
    let result = false;
    if (this.selectedMenus.find(element => item.id == element.id)) {
      result = true;
    }
    return result;
  }

  isCheckedAll(menus) {
    let result = false;
    menus.forEach(element => {
      result = this.isMenuChecked(element);
      if (element.childs.length > 0) {
        element.childs.forEach(item => {
          result = this.isMenuChecked(element);
        });
      }
    });
    return result
  };

  clearSelectedMenus(menus) {
    this.selectedMenus = [];
    this.isCheckedAll(menus);
    return this.selectedMenus;
  }

  // isIndeterminate(menus) {
  //   let result = false;
  //   if (this.selectedMenus.length > 0 && !this.isCheckedAll(menus)) {
  //     result = true;
  //   }
  //   return result;
  // }


}
